import { EditLocationAlt, MyLocation } from "@mui/icons-material";
import { IconButton, Stack, TextField, Tooltip } from "@mui/material";
import { t } from "i18next";

interface LocationFieldProps {
  location: { lat: number; lng: number; name: string } | null;
  getLocation: () => void;
  setOpenMap: (open: boolean) => void;
  loadingLocation: boolean;
}

const LocationField: React.FC<LocationFieldProps> = ({
  location,
  getLocation,
  setOpenMap,
  loadingLocation,
}) => {
  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <TextField
        label={t("pages.currentlyReading.form.place")}
        value={
          location
            ? `${location.name || "Selected"} (${location.lat.toFixed(
                5
              )}, ${location.lng.toFixed(5)})`
            : ""
        }
        fullWidth
        required
        slotProps={{
          input: {
            readOnly: true,
          },
        }}
      />

      {!location ? (
        <Tooltip title={t("pages.currentlyReading.tooltip.setLocation")} arrow>
          <IconButton onClick={getLocation} disabled={loadingLocation}>
            <MyLocation color={location ? "primary" : "action"} />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title={t("pages.currentlyReading.tooltip.editLocation")} arrow>
          <IconButton onClick={() => setOpenMap(true)}>
            <EditLocationAlt color="primary" />
          </IconButton>
        </Tooltip>
      )}
    </Stack>
  );
};

export default LocationField;
